import { render, staticRenderFns } from "./CPDueDiligenceDocumentsOverview.vue?vue&type=template&id=0a174d67&scoped=true&"
import script from "./CPDueDiligenceDocumentsOverview.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceDocumentsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceDocumentsOverview.vue?vue&type=style&index=0&id=0a174d67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a174d67",
  null
  
)

export default component.exports